var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2104 15.89C20.5742 17.3945 19.5792 18.7202 18.3123 19.7513C17.0454 20.7824 15.5452 21.4874 13.9428 21.8048C12.3405 22.1221 10.6848 22.0421 9.12055 21.5718C7.55627 21.1014 6.13103 20.2551 4.96942 19.1067C3.80782 17.9582 2.94522 16.5428 2.45704 14.9839C1.96886 13.4251 1.86996 11.7705 2.169 10.1646C2.46804 8.55878 3.1559 7.05063 4.17245 5.77203C5.189 4.49343 6.50329 3.48332 8.0004 2.83M22.0004 12C22.0004 10.6868 21.7417 9.38642 21.2392 8.17317C20.7367 6.95991 20.0001 5.85752 19.0715 4.92893C18.1429 4.00035 17.0405 3.26375 15.8272 2.7612C14.614 2.25866 13.3136 2 12.0004 2V12H22.0004Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilization);
export default __webpack_public_path__ + "static/media/Utilization.115a196b75d3d575c04d8c6f9ea1c1d2.svg";
export { ForwardRef as ReactComponent };